import type { ComponentType } from "react";
import {
	IconArtboard,
	IconBrain,
	IconMessage,
	IconWriting,
	IconBook,
} from "@/lib/tabler-icons";

export interface ResumenAccion {
	title: string;
	description: string;
	Icon: ComponentType<{ className?: string }>;
	stats?: string;
	testimonial?: string;
}

export const resumenAcciones: ResumenAccion[] = [
	{
		title: "Ponencia escénica",
		description:
			"Una experiencia artística y emocional que combina palabra, danza flamenca e imagen para cuestionar la idealización de la familia. Visibiliza las heridas invisibles de la infancia y la necesidad de reparación. Conecta lo íntimo con lo colectivo, lo personal con lo social. Genera un espacio de conciencia y autocuidado compartido. Se realiza en fechas clave como el 25N o el Día de la Infancia.",
		Icon: IconArtboard,
		stats: "Más de 250 asistentes en la ponencia realizada en Telde",
	},
	{
		title: "TALLER Matrices de Aprendizaje",
		description:
			"Dirigido a familias, propone revisar la historia personal y el estilo educativo. Se trabajan herramientas de comunicación no violenta y gestión emocional. Busca romper patrones de violencia y fomentar vínculos más sanos. Promueve la reflexión sobre la parentalidad consciente. Se adapta a centros educativos, entidades y empresas.",
		Icon: IconBrain,
		testimonial:
			"Lo que más interesante me pareció fue el autoanálisis, permitiendo autocríticas constructivas que nos pueden permitir mejorar la relación no solo con nuestros hijos, sino con nuestro entorno y con nosotras mismas.",
	},
	{
		title: "TALLER Lo que no te cuentan",
		description:
			"Pensado para jóvenes de 16 a 21 años en contextos educativos y sociales. Aborda los vínculos aprendidos y la dependencia emocional. Se reflexiona sobre las consecuencias de la negligencia educativa. Incluye dinámicas participativas y emocionales de grupo. Favorece el reconocimiento de la propia historia personal.",
		Icon: IconMessage,
		stats:
			"Más de 150 adolescentes del sur de la isla transformaron su experiencia en relatos escritos como resultado del taller.",
	},
	{
		title: "TALLER Narrar nuestra propia historia",
		description:
			"Dirigido a mujeres adultas - extensible a población general - que desean resignificar su recorrido vital. Se utiliza la escritura, la música y la memoria como herramientas. Trabaja la línea de vida y la resignificación de la infancia. Favorece vínculos más sanos consigo mismas y con los demás. Genera espacios de encuentro, autocuidado y empoderamiento.",
		Icon: IconWriting,
		stats:
			"Herramientas utilizadas con más de 300 mujeres víctimas de violencia de género a las que he acompañado como trabajadora social, obteniendo óptimos resultados.",
	},
	{
		title: "Clubes y planes de lectura",
		description:
			"La novela TODO LO QUE NO VES se convierte en herramienta pedagógica. Puede presentarse en formato de coloquio abierto o de lectura guiada. Favorece el debate sobre violencia intrafamiliar, abuso y resiliencia. Incluye la posibilidad de compra institucional con precio reducido. Impulsa la reflexión colectiva a través de la literatura.",
		Icon: IconBook,
		testimonial:
			"Ya hemos podido leer tu libro y nos ha gustado mucho, sobre todo las reflexiones que propones. Nos parece una buena idea que seas nuestra invitada especial para la reading party.",
	},
];
